import { IErrorPayload } from "@/fe-core/meta/interfaces/root";
import {
  ClearOptInOutJackpotMessageAction,
  OptInJackpotFailureAction,
  OptInJackpotRequestAction,
  OptInJackpotSuccessAction,
  optInOutJackpotActionTypes,
  OptOutJackpotFailureAction,
  OptOutJackpotRequestAction,
  OptOutJackpotSuccessAction,
} from "@/fe-core/meta/types/optInOutJackpot";

export const optInJackpotRequest = (
  payload: string
): OptInJackpotRequestAction => ({
  type: optInOutJackpotActionTypes.OPT_IN_JACKPOT_REQUEST,
  payload,
});

export const optInJackpotSuccess = (payload: {
  message: string;
}): OptInJackpotSuccessAction => ({
  type: optInOutJackpotActionTypes.OPT_IN_JACKPOT_SUCCESS,
  payload,
});

export const optInJackpotFailure = (
  payload: IErrorPayload
): OptInJackpotFailureAction => ({
  type: optInOutJackpotActionTypes.OPT_IN_JACKPOT_FAILURE,
  payload,
});

export const optOutJackpotRequest = (
  payload: string
): OptOutJackpotRequestAction => ({
  type: optInOutJackpotActionTypes.OPT_OUT_JACKPOT_REQUEST,
  payload,
});

export const optOutJackpotSuccess = (payload: {
  message: string;
}): OptOutJackpotSuccessAction => ({
  type: optInOutJackpotActionTypes.OPT_OUT_JACKPOT_SUCCESS,
  payload,
});

export const optOutJackpotFailure = (
  payload: IErrorPayload
): OptOutJackpotFailureAction => ({
  type: optInOutJackpotActionTypes.OPT_OUT_JACKPOT_FAILURE,
  payload,
});

export const clearOptInOutJackpotMessage =
  (): ClearOptInOutJackpotMessageAction => ({
    type: optInOutJackpotActionTypes.CLEAR_OPT_IN_OUT_JACKPOT_MESSAGE,
  });
